export default "__VITE_ASSET__2c309c94__"